(function ($) {

    // Scripts which runs after DOM load

    $(document).ready(function () {

        //Testimonials
        document.querySelectorAll('.testimonials-slider__slides').forEach((el) => {
            const autoplay = el.dataset.autoplay === 'true';
            const loop     = el.dataset.loop === 'true';
            const speed    = parseInt(el.dataset.speed, 10) || 3000;

            new Swiper(el, {
                loop: loop,
                slidesPerView: 1,
                spaceBetween: 20,
                speed: 600,

                autoplay: autoplay ? {
                    delay: speed,
                    disableOnInteraction: false,
                } : false,

                pagination: {
                    el: el.closest('.testimonials-slider')?.querySelector('.testimonials-slider__dots .swiper-pagination'),
                    clickable: true,
                },

                navigation: {
                    prevEl: el.closest('.testimonials-slider')?.querySelector('.testimonials-slider__controls-button-prev'),
                    nextEl: el.closest('.testimonials-slider')?.querySelector('.testimonials-slider__controls-button-next'),
                },
            });
        });



        function initTabs(root) {
            const profiles = [...root.querySelectorAll('.testimonials-tabs__profiles .testimonials-tabs__profile')];
            const reviews  = [...root.querySelectorAll('.testimonials-tabs__reviews  .testimonials-tabs__review')];
            const reviewsWrapper = root.querySelector('.testimonials-tabs__reviews');
            if (!profiles.length || !reviews.length || !reviewsWrapper) return;

            const mql = window.matchMedia('(min-width: 1201px)');
            let current = 0;
            const crossfade = (oldEl, newEl, cb) => {
                if (oldEl === newEl) {
                    newEl.hidden = false;
                    newEl.classList.add('is-active');
                    cb && cb();
                    return;
                }

                newEl.hidden = false;
                newEl.classList.add('is-active');

                if (oldEl) {
                    oldEl.classList.add('is-leaving');
                    oldEl.classList.remove('is-active');
                    const onEnd = () => {
                        oldEl.hidden = true;
                        oldEl.classList.remove('is-leaving');
                        oldEl.removeEventListener('transitionend', onEnd);
                        cb && cb();
                    };
                    oldEl.addEventListener('transitionend', onEnd);
                    setTimeout(onEnd, 350);
                } else {
                    cb && cb();
                }
            };

            const placeReview = (idx) => {
                const next = reviews[idx];
                if (!next) return;

                const active = reviews.find(el => el.classList.contains('is-active') && !el.hidden) || null;

                if (mql.matches) {
                    reviews.forEach((x) => { if (x.parentNode !== reviewsWrapper) reviewsWrapper.appendChild(x); });
                    crossfade(active, next);
                    reviews.forEach((x, i) => { if (i !== idx) { x.hidden = true; x.classList.remove('is-active','is-leaving'); } });
                } else {

                    const p = profiles[idx];
                    if (!p) return;
                    if (p.nextElementSibling !== next) p.after(next);
                    crossfade(active, next, () => {
                        reviews.forEach((x, i) => { if (i !== idx) { x.hidden = true; x.classList.remove('is-active','is-leaving'); } });
                    });
                }
            };

            const activate = (idx) => {
                current = idx;
                profiles.forEach((p, i) => p.classList.toggle('is-active', i === idx));
                placeReview(idx);
            };

            profiles.forEach((p, i) => {
                p.addEventListener('click', () => activate(i));
                p.addEventListener('keydown', (e) => {
                    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); activate(i); }
                    if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
                        e.preventDefault();
                        const next = e.key === 'ArrowRight' ? (i + 1) % profiles.length : (i - 1 + profiles.length) % profiles.length;
                        profiles[next].focus();
                        activate(next);
                    }
                });
            });

            (mql.addEventListener ? mql.addEventListener('change', () => placeReview(current))
                : mql.addListener(() => placeReview(current)));

            reviews.forEach((x, i) => { x.hidden = i !== 0; x.classList.remove('is-active','is-leaving'); });
            reviews[0].hidden = false;
            reviews[0].classList.add('is-active');
            profiles[0]?.classList.add('is-active');
        }
        document.querySelectorAll('.testimonials-tabs__tabs').forEach(initTabs);

        document.querySelectorAll('.js-faq-list').forEach((faqList) => {
            const switchStateClasses = (item, isOpen) => {
                const trigger = item.querySelector('.js-faq-trigger');
                const answer = item.querySelector('.js-faq-answer');

                item.classList.toggle('is-open', isOpen);

                if (trigger) {
                    trigger.setAttribute('aria-expanded', String(isOpen));
                }

                if (answer) {
                    answer.hidden = !isOpen;
                }
            };

            const closeOtherItems = (currentItem) => {
                faqList.querySelectorAll('.js-faq-item.is-open').forEach((item) => {
                    if (item !== currentItem) {
                        switchStateClasses(item, false);
                    }
                });
            };

            faqList.addEventListener('click', (event) => {
                const trigger = event.target.closest('.js-faq-trigger');

                if (!trigger || !faqList.contains(trigger)) {
                    return;
                }

                const item = trigger.closest('.js-faq-item');
                if (!item) return;

                const isOpen = item.classList.contains('is-open');

                closeOtherItems(item);
                switchStateClasses(item, !isOpen);
            });
        });
     ///

            initMultiColumnSlider();

            let resizeTimer;

            $(window).on('resize', function () {
                clearTimeout(resizeTimer);

                resizeTimer = setTimeout(function () {
                    document.querySelectorAll('.js-multicolumn-slider').forEach((slider) => {
                        if (slider.swiper) {
                            slider.swiper.destroy(true, true);
                        }
                    });

                    initMultiColumnSlider();
                }, 200);
            });


        function initMultiColumnSlider() {
            const sliders = document.querySelectorAll('.js-multicolumn-slider');

            sliders.forEach((slider) => {
                const section = slider.closest('.multicolumn-slider');
                if (!section) return;

                const isMobile = window.innerWidth <= 1024;

                const prevBtn = isMobile
                    ? section.querySelector('.js-multicolumn-prev-mobile')
                    : section.querySelector('.js-multicolumn-prev');

                const nextBtn = isMobile
                    ? section.querySelector('.js-multicolumn-next-mobile')
                    : section.querySelector('.js-multicolumn-next');

                const lineFill = isMobile
                    ? section.querySelector('.js-multicolumn-line-mobile')
                    : section.querySelector('.js-multicolumn-line');

                new Swiper(slider, {
                    slidesPerView: 1.5,
                    spaceBetween: 12,
                    speed: 600,
                    watchOverflow: true,

                    navigation: {
                        prevEl: prevBtn,
                        nextEl: nextBtn,
                    },

                    breakpoints: {
                        768: {
                            slidesPerView: 2.2,
                            spaceBetween: 20,
                        },
                        1024: {
                            slidesPerView: 4,
                            spaceBetween: 24,
                        },
                    },

                    on: {
                        init: function () {
                            updateSliderLine(this, lineFill);
                            updateSliderNavState(this, prevBtn, nextBtn);
                        },

                        slideChange: function () {
                            updateSliderLine(this, lineFill);
                            updateSliderNavState(this, prevBtn, nextBtn);
                        },

                        resize: function () {
                            updateSliderLine(this, lineFill);
                            updateSliderNavState(this, prevBtn, nextBtn);
                        },

                        progress: function () {
                            updateSliderLine(this, lineFill);
                        }
                    }
                });
            });
        }

        function updateSliderLine(swiper, lineFill) {
            if (!swiper || !lineFill) return;

            const progress = Math.min(Math.max(swiper.progress || 0, 0), 1);

            let width = progress * 100;

            if (!swiper.isLocked && width === 0) {
                width = 8;
            }

            lineFill.style.width = `${width}%`;
        }

        function updateSliderNavState(swiper, prevBtn, nextBtn) {
            const isLocked = swiper.isLocked;

            if (prevBtn) prevBtn.disabled = swiper.isBeginning || isLocked;
            if (nextBtn) nextBtn.disabled = swiper.isEnd || isLocked;

            const section = swiper.el.closest('.multicolumn-slider');
            if (!section) return;

            section.classList.toggle('is-slider-locked', isLocked);
            section.classList.toggle('has-slider-nav', !isLocked);

            const hasContainerParent = !!swiper.el.closest('.container');
            section.classList.toggle('has-parent-container', hasContainerParent);
        }
        ////
        let latestPostsSwiper = null;

        function initLatestPostsSwiper() {
            const slider = document.querySelector('.latest-posts__slider');

            if (!slider || typeof Swiper === 'undefined') return;

            if (window.innerWidth < 768) {
                if (!latestPostsSwiper) {
                    latestPostsSwiper = new Swiper(slider, {
                        slidesPerView: 1.15,
                        spaceBetween: 16,
                        speed: 500,
                        watchOverflow: true,
                        navigation: {
                            nextEl: slider.querySelector('.latest-posts__next'),
                            prevEl: slider.querySelector('.latest-posts__prev'),
                        },
                        pagination: {
                            el: slider.querySelector('.latest-posts__pagination'),
                            type: 'progressbar',
                        },
                    });
                }
            } else {
                if (latestPostsSwiper) {
                    latestPostsSwiper.destroy(true, true);
                    latestPostsSwiper = null;
                }

                slider.classList.remove('swiper-initialized', 'swiper-horizontal', 'swiper-backface-hidden');

                const wrapper = slider.querySelector('.latest-posts__grid');
                const slides = slider.querySelectorAll('.latest-posts__item');

                if (wrapper) {
                    wrapper.removeAttribute('style');
                }

                slides.forEach((slide) => {
                    slide.removeAttribute('style');
                });
            }
        }

        initLatestPostsSwiper();
        window.addEventListener('resize', initLatestPostsSwiper);

        //

        let serviceCardsSwipers = [];

        function initServiceCardsSliders() {
            document.querySelectorAll('.js-service-cards-slider').forEach((slider) => {
                if (slider.swiper) {
                    slider.swiper.destroy(true, true);
                }

                const wrapper = slider.querySelector('.service-cards-section__items');
                const slides = slider.querySelectorAll('.service-cards-section__item');

                if (window.innerWidth >= 768) {
                    slider.classList.remove(
                        'swiper-initialized',
                        'swiper-horizontal',
                        'swiper-backface-hidden'
                    );

                    if (wrapper) {
                        wrapper.removeAttribute('style');
                    }

                    slides.forEach((slide) => {
                        slide.removeAttribute('style');
                    });

                    return;
                }

                const section = slider.closest('.service-cards-section');
                const prevBtn = section?.querySelector('.js-service-cards-prev');
                const nextBtn = section?.querySelector('.js-service-cards-next');
                const progressFill = section?.querySelector('.js-service-cards-progress');

                const swiper = new Swiper(slider, {
                    slidesPerView: 1.35,
                    spaceBetween: 16,
                    speed: 500,
                    watchOverflow: true,

                    navigation: {
                        prevEl: prevBtn,
                        nextEl: nextBtn,
                    },

                    on: {
                        init: function () {
                            updateServiceCardsProgress(this, progressFill);
                            updateServiceCardsNavState(this, prevBtn, nextBtn);
                        },
                        slideChange: function () {
                            updateServiceCardsProgress(this, progressFill);
                            updateServiceCardsNavState(this, prevBtn, nextBtn);
                        },
                        resize: function () {
                            updateServiceCardsProgress(this, progressFill);
                            updateServiceCardsNavState(this, prevBtn, nextBtn);
                        },
                    },
                });

                serviceCardsSwipers.push(swiper);
            });
        }

        function updateServiceCardsProgress(swiper, progressFill) {
            if (!swiper || !progressFill) return;

            const progress = Math.min(Math.max(swiper.progress || 0, 0), 1);
            const track = progressFill.parentElement;
            if (!track) return;

            const trackWidth = track.offsetWidth;
            const fillWidth = progressFill.offsetWidth || 80;
            const maxTranslate = Math.max(trackWidth - fillWidth, 0);

            progressFill.style.transform = `translateX(${maxTranslate * progress}px)`;
        }

        function updateServiceCardsNavState(swiper, prevBtn, nextBtn) {
            const isLocked = swiper.isLocked;

            if (prevBtn) prevBtn.disabled = swiper.isBeginning || isLocked;
            if (nextBtn) nextBtn.disabled = swiper.isEnd || isLocked;
        }

        initServiceCardsSliders();

        let serviceCardsResizeTimer;

        window.addEventListener('resize', function () {
            clearTimeout(serviceCardsResizeTimer);

            serviceCardsResizeTimer = setTimeout(function () {
                serviceCardsSwipers.forEach((swiper) => {
                    if (swiper && !swiper.destroyed) {
                        swiper.destroy(true, true);
                    }
                });

                serviceCardsSwipers = [];

                initServiceCardsSliders();
            }, 200);
        });

        // Testimonials Stats
        const testimonialsStatsCounter = () => {
            const $statSections = $('.testimonials');

            if ($statSections.length === 0) return;

            // Settings for the observer
            const observerOptions = {
                root: null,
                rootMargin: '0px',
                threshold: 0.5
            };

            const observer = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        // We transform the resulting section into a jQuery object
                        const $currentSection = $(entry.target);

                        // Search for counters inside the section and iterate over them
                        $currentSection.find('.js-counter').each(function(index) {
                            const $el = $(this);
                            const targetString = $el.attr('data-target');
                            const targetValue = parseFloat(targetString);

                            const isFloat = targetString.includes('.');
                            const decimals = isFloat ? 1 : 0;

                            const options = {
                                decimalPlaces: decimals,
                                duration: 2,
                                useGrouping: true,
                                separator: ',',
                                decimal: '.',
                            };

                            const countUpAnim = new countUp.CountUp(this, targetValue, options);

                            const delay = index * 200;

                            setTimeout(() => {
                                if (!countUpAnim.error) {
                                    countUpAnim.start();
                                } else {
                                    console.error('CountUp error:', countUpAnim.error);
                                }
                            }, delay);
                        });

                        // Disable observer tracking
                        observer.unobserve(entry.target);
                    }
                });
            }, observerOptions);

            $statSections.each(function() {
                observer.observe(this);
            });
        }
        testimonialsStatsCounter();

        //image testimonials slider
        const testimonialsSlider = () => {
            let testimonialsSliders = $(".js-testimonials-slider");

            if (!testimonialsSliders.length) return;

            testimonialsSliders.each(function () {
                new Swiper( this, {
                    loop: false,
                    slidesPerView: 1.2,
                    spaceBetween: 12,
                    navigation: {
                        nextEl: ".js-testimonials-next",
                        prevEl: ".js-testimonials-prev",
                    },
                    pagination: {
                        el: ".testimonials__slider-nav-progressbar",
                        type: "progressbar"
                    },
                    breakpoints: {
                        768: {
                            slidesPerView: 2.5,
                            spaceBetween: 24
                        },
                        1200: {
                            slidesPerView: 3.5,
                            spaceBetween: 24
                        },
                        1441: {
                            slidesPerView: 4.5,
                            spaceBetween: 24
                        }
                    },
                    a11y: {
                        enabled: true,
                        prevSlideMessage: 'Prev slide',
                        nextSlideMessage: 'Next slide'
                    },
                    keyboard: {
                        enabled: true,
                        onlyInViewport: true,
                    }
                });
            });

            let $lastFocusedCard; // Variable to store the slide that was clicked

            $(document).on('click keydown', '.testimonials__yext-reviews-item:not(.modal)', function(e) {

                // Keyboard processing (WCAG)
                if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') {
                    return;
                }
                if (e.type === 'keydown') {
                    e.preventDefault();
                }

                $lastFocusedCard = $(this); // Remember the slide to return focus

                let $section = $(this).closest('.testimonials');
                let modalId = $section.attr('data-modal-id');
                let modalItemId = $(this).attr('data-modal-item-id');

                let $modalBox = $('.testimonials__yext-reviews-modal[data-modal-id="' + modalId + '"]');
                if (!$modalBox.length) return;

                let $targetReview = $modalBox.find('.testimonials__yext-reviews-item.modal[data-modal-item-id="' + modalItemId + '"]');

                $modalBox.find('.testimonials__yext-reviews-item.modal').hide();

                $targetReview.fadeIn(400);

                $modalBox.fadeIn(300, function() {
                    // WCAG: Move focus to the close button inside this particular modal
                    $(this).find('.testimonials__yext-reviews-modal-box-close').focus();
                    let scrollWidth = getScrollbarWidth();
                    $('body').css('--scrollbar-width', scrollWidth + 'px').addClass('no-scroll');
                });
            });

            // Close by clicking the cross button
            $(document).on('click', '.testimonials__yext-reviews-modal .testimonials__yext-reviews-modal-box-close', function() {
                let $modal = $(this).closest('.testimonials__yext-reviews-modal');
                closeModalSmoothly($modal);
            });

            // Close by clicking on overlay
            $(document).on('click', '.testimonials__yext-reviews-modal', function(e) {
                if ($(e.target).is(this)) {
                    closeModalSmoothly($(this));
                }
            });

            // Closing with the Escape key
            $(document).on('keydown', function(e) {
                if (e.key === 'Escape') {
                    // Close any visible modal on the page.
                    let $visibleModal = $('.testimonials__yext-reviews-modal:visible');
                    if ($visibleModal.length) {
                        closeModalSmoothly($visibleModal);
                    }
                }
            });

            function getScrollbarWidth() {
                return window.innerWidth - document.documentElement.clientWidth;
            }

            function closeModalSmoothly($modalToClose) {
                $modalToClose.fadeOut(300, function() {
                    $(this).find('.testimonials__yext-reviews-item.modal').hide();
                    $('body').removeClass('no-scroll').css('--scrollbar-width', '0px');
                });
            }
        };
        testimonialsSlider();

        const logotypesCarousel = () => {
            let logotypesCarousel = $(".js-logotypes-carousel");

            if (!logotypesCarousel.length) return;

            logotypesCarousel.each(function () {
                new Swiper(this, {
                    loop: true,
                    speed: 4000,
                    slidesPerView: 'auto',
                    spaceBetween: 52,
                    allowTouchMove: false,
                    autoplay: {
                        delay: 0,
                        disableOnInteraction: false
                    }
                });
            });
        }
        logotypesCarousel();

        const mediaSlider = () => {
            let mediaSlider = $(".media-slider");

            if (!mediaSlider.length) return false;

            mediaSlider.each(function () {
                const slider = this.querySelector('.js-media-slider-carousel');
                const btnNext = this.querySelector('.js-media-slider-next');
                const btnPrev = this.querySelector('.js-media-slider-prev');
                const scrollbarEl = this.querySelector('.media-slider__slider-nav-progressbar');

                new Swiper(slider, {
                    loop: true,
                    slidesPerView: 1.2,
                    spaceBetween: 12,
                    centeredSlides: true,
                    navigation: {
                        nextEl: btnNext,
                        prevEl: btnPrev,
                    },
                    pagination: {
                        el: scrollbarEl,
                        type: "progressbar"
                    },
                    breakpoints: {
                        768: {
                            slidesPerView: 2,
                            spaceBetween: 24
                        }
                    },
                    a11y: {
                        enabled: true,
                        prevSlideMessage: 'Previous slide',
                        nextSlideMessage: 'Next slide',
                        firstSlideMessage: 'This is the first slide',
                        lastSlideMessage: 'This is the last slide',
                        slideRole: 'group',
                    },
                    keyboard: {
                        enabled: true,
                        onlyInViewport: true,
                    }
                });
            });

            // GLightbox initialization
            const lightbox = GLightbox({
                selector: '.glightbox',
                touchNavigation: true,
                loop: true,
                zoomable: false,
                plyr: {
                    css: 'https://cdn.plyr.io/3.6.12/plyr.css',
                    config: {
                        ratio: '16:9',
                        muted: false,
                        hideControls: true,
                    }
                }
            });
        }
        mediaSlider();

        const iconsRowSlider = () => {
            const sections = $(".icons-row");

            if (!sections.length) return false;

            let swiperInstances = [];
            const mediaQuery = window.matchMedia('(max-width: 767px)');

            function handleSwiper() {
                if (mediaQuery.matches) {
                    if (swiperInstances.length === 0) {
                        sections.each(function () {
                            const slider = this.querySelector('.js-icons-row-mobile-swiper');
                            const scrollbarEl = this.querySelector('.icons-row__slider-progressbar');
                            const prevEl = this.querySelector('.icons-row__slider-arrow--prev');
                            const nextEl = this.querySelector('.icons-row__slider-arrow--next');

                            if (slider) {
                                const swiper = new Swiper(slider, {
                                    loop: false,
                                    slidesPerView: 2,
                                    spaceBetween: 20,

                                    navigation: {
                                        prevEl: prevEl,
                                        nextEl: nextEl,
                                    },

                                    pagination: {
                                        el: scrollbarEl,
                                        type: 'progressbar',
                                    },

                                    a11y: {
                                        enabled: true,
                                        prevSlideMessage: 'Previous slide',
                                        nextSlideMessage: 'Next slide',
                                        firstSlideMessage: 'This is the first slide',
                                        lastSlideMessage: 'This is the last slide',
                                        slideRole: 'group',
                                    },

                                    keyboard: {
                                        enabled: true,
                                        onlyInViewport: true,
                                    },
                                });

                                swiperInstances.push(swiper);
                            }
                        });
                    }
                } else {
                    if (swiperInstances.length > 0) {
                        swiperInstances.forEach(swiper => {
                            swiper.destroy(true, true);
                        });

                        swiperInstances = [];
                    }
                }
            }

            handleSwiper();
            mediaQuery.addEventListener('change', handleSwiper);
        };

        iconsRowSlider();

        const locationLiveSearchWorker = () => {
            const locationSearchInputs = $('input[name="search_location"]');
            if (!locationSearchInputs.length) return false;

            $(document).on('click', function(e) {
                if (!$(e.target).closest('input[name="search_location"], .location-live-search-dropdown').length) {
                    $('.location-live-search-dropdown').empty().hide();
                    locationSearchInputs.attr('aria-expanded', 'false'); // WCAG
                }
            });

            locationSearchInputs.each(function (index) {
                const input = $(this);
                const submitBtn = input.closest('form').find('.search-form-submit-link');
                let debounceTimer;
                const debounceDelay = 500;

                // Unique ID for linking the input and its list (needed for aria-controls)
                const dropdownId = 'location-dropdown-' + index;

                // Initialize ARIA attributes for the input
                input.attr({
                    'role': 'combobox',
                    'aria-autocomplete': 'list',
                    'aria-expanded': 'false',
                    'aria-controls': dropdownId
                });

                let dropdown = input.next('.location-live-search-dropdown');
                if (!dropdown.length) {
                    dropdown = $('<div class="location-live-search-dropdown" style="display: none;"></div>');
                    input.after(dropdown);
                }

                const closeDropdown = () => {
                    dropdown.empty().hide();
                    input.attr('aria-expanded', 'false');
                };

                // WCAG: KEYBOARD NAVIGATION (Keystrokes within input)
                input.on('keydown', function(e) {
                    if (dropdown.is(':visible')) {
                        if (e.key === 'ArrowDown') {
                            e.preventDefault(); // Disable page scrolling
                            // move the focus to the first link in the dropdown
                            dropdown.find('a').first().focus();
                        } else if (e.key === 'Escape') {
                            closeDropdown();
                        }
                    }
                });

                // WCAG: KEYBOARD NAVIGATION (Keys within a dropdown)
                dropdown.on('keydown', 'a', function(e) {
                    const links = dropdown.find('a');
                    const currentIndex = links.index(this);

                    if (e.key === 'ArrowDown') {
                        e.preventDefault();
                        if (currentIndex < links.length - 1) {
                            links.eq(currentIndex + 1).focus(); // go to the next link
                        }
                    } else if (e.key === 'ArrowUp') {
                        e.preventDefault();
                        if (currentIndex > 0) {
                            links.eq(currentIndex - 1).focus(); // go to the previous link
                        } else {
                            // If we are on the first element and press Up -> we return to the input
                            input.focus();
                        }
                    } else if (e.key === 'Escape') {
                        e.preventDefault();
                        input.focus(); // Return focus to the input before closing
                        closeDropdown();
                    }
                });

                input.on('input', function() {
                    const val = $(this).val().trim();

                    clearTimeout(debounceTimer);

                    if (val.length < 3) {
                        closeDropdown();
                        return;
                    }

                    // Check if the input is a ZIP code (only numbers, spaces and hyphens)
                    const isZipCode = /^[\d\s\-]+$/.test(val);

                    if (isZipCode) {
                        closeDropdown();
                        return;
                    }

                    debounceTimer = setTimeout(function() {

                        input.addClass('is-loading');
                        submitBtn.addClass('is-loading');

                        $.ajax({
                            url: '/wp-json/restopros/v1/location-search-live',
                            type: 'GET',
                            data: {
                                query: val
                            },
                            success: function(response) {
                                dropdown.empty();

                                if (response.length > 0) {
                                    const list = $('<ul class="location-search-dropdown__list"></ul>');

                                    response.forEach(item => {

                                        const locationName = item.location_name ? ` <span class="location-name" style="font-size: 0.9em; color: #666;">(${item.location_name})</span>` : '';

                                        const listItem = $(`<li class="location-live-search-dropdown__item">
                                        <a href="${item.location_url}" class="location-live-search-dropdown__link" style="display: block; padding: 10px; text-decoration: none; color: inherit;">
                                            <strong>${item.city}</strong>, ${item.location_state}${locationName}
                                        </a>
                                    </li>`);
                                        list.append(listItem);
                                    });

                                    dropdown.append(list).show();
                                } else {
                                    dropdown.append('<div class="location-live-search-dropdown__no-results" style="padding: 10px;">No locations found for "'+ val +'".</div>').show();
                                }
                            },
                            error: function(xhr, status, error) {
                                console.error('REST API ERROR:', error);
                            },
                            complete: function() {
                                input.removeClass('is-loading');
                                submitBtn.removeClass('is-loading');
                            }
                        });

                    }, debounceDelay);
                });
            });
        };
        locationLiveSearchWorker();
    });


}(jQuery));

document.addEventListener('DOMContentLoaded', function () {

    const trigger = document.getElementById('toggle-menu');
    const menu = document.getElementById('header-menu');

    if (!trigger || !menu) return;

    trigger.addEventListener('click', function () {

        trigger.classList.toggle('active');
        menu.classList.toggle('open');
        document.body.classList.toggle('menu-open');

    });

    const parents = menu.querySelectorAll('.menu-item-has-children > a');

    parents.forEach(function (link) {

        link.addEventListener('click', function (e) {

            if (window.innerWidth > 1024) {
                return;
            }

            e.preventDefault();

            const parent = link.parentElement;

            parent.classList.toggle('active');

        });

    });

});


document.addEventListener('DOMContentLoaded', () => {
    const groups = document.querySelectorAll('.locations-section__group');

    groups.forEach((group, index) => {
        const trigger = group.querySelector('.locations-section__subtitle');

        if (!trigger) return;

        if (index === 0) {
            group.classList.add('is-active');
        }

        trigger.addEventListener('click', () => {
            const isActive = group.classList.contains('is-active');

            groups.forEach((currentGroup) => {
                currentGroup.classList.remove('is-active');
            });

            if (!isActive) {
                group.classList.add('is-active');
            }
        });
    });
});
